// The merchant's pass to their own storefront: the check that decides whether the merchant bar is drawn.
import { fetchApi } from './client';

/** What a valid pass answers with: until when, the theme the bar names, and the admin its Customize opens. */
export type MerchantPassCheck =
  | { valid: false }
  | { valid: true; expiresAt: string; adminUrl: string; theme: { handle: string; name: string } };

// Asks the store whether a pass is its own and still good.
export function verifyMerchantPass(token: string): Promise<MerchantPassCheck> {
  return fetchApi<MerchantPassCheck>(`/tenant/storefront-pass/verify?token=${encodeURIComponent(token)}`);
}
